declare global {
    interface Window { gtag: any; }
}
export const sendLocationToGtag = (location: string, pageTitle: string = "") => {
    const defaultPageTitle = "ミルモリズム";
    document.title = pageTitle? `${defaultPageTitle} | ${pageTitle}` : defaultPageTitle;

    if (!window.gtag) return;

    window.gtag("config", "G-FSP8ED8B8M", {
        page_path: location
    });
};
